import Head from 'next/head';
import { useRouter } from 'next/router';
import { metadadosDaRota } from '@utils/seo';

/**
 * O `<head>` de todas as 107 rotas, tirado de `utils/seo`.
 *
 * Antes daqui havia um `<title>` global e nada mais: as 107 rotas serviam o mesmo título, sem
 * description e sem canonical, e para o Google isso é um conjunto de páginas indistinguíveis — o
 * comportamento esperado dele é colapsar as duplicatas e manter uma só.
 *
 * Montado no `_app` FORA do `SessionProvider`, no lugar em que o `<title>` global estava: na carga
 * inicial os três wrappers de página curto-circuitam enquanto a sessão não resolve, e daqui para
 * dentro nada chega a montar. O título ficaria vazio até lá — a aba mostraria a URL crua, e o
 * `page_view` de entrada sairia sem `page_title`, porque `initGoogleAnalytics` lê `document.title`
 * no efeito de montagem.
 */
export const Seo = () => {
  const router = useRouter();
  const metadados = metadadosDaRota(router.pathname);

  return (
    <Head>
      <title>{metadados.title}</title>

      {metadados.description ? (
        <meta name="description" content={metadados.description} />
      ) : null}

      {metadados.canonical ? (
        <link rel="canonical" href={metadados.canonical} />
      ) : null}

      {metadados.indexavel ? null : (
        <meta name="robots" content="noindex,nofollow" />
      )}
    </Head>
  );
};
